import { useCMSPageField } from '@/cms/fields';

export interface AccommodationContext {
  accoId: string;
  contextItemId: string;
  bookingGateId: string;
  image: string;
  name: string;
  alertServiceDataSourceId: string;
  promotedPriceId: string;
}

export const useAccommodationContext = (): AccommodationContext => {
  const accommodationId = useCMSPageField('PDP.id');
  const productId = useCMSPageField('PDP.productId');
  const name = useCMSPageField('PDP.title');
  const images = useCMSPageField('PDP.media');
  const bookingGateId = useCMSPageField('PDP.bookingGateId');
  const promotedPriceId = useCMSPageField('PDP.promotedPriceId');

  return {
    contextItemId: accommodationId,
    accoId: String(productId),
    name,
    image: images[0]?.src,
    // Hardcodes since it is the same for a single publication.
    bookingGateId,
    alertServiceDataSourceId: 'ebf38746-580f-46f6-8183-d5ccfc728d93',
    promotedPriceId,
  };
};
